import { render, staticRenderFns } from "./fix-anchor.vue?vue&type=template&id=2af12f5f&scoped=true&"
import script from "./fix-anchor.vue?vue&type=script&lang=js&"
export * from "./fix-anchor.vue?vue&type=script&lang=js&"
import style0 from "./fix-anchor.vue?vue&type=style&index=0&id=2af12f5f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af12f5f",
  null
  
)

export default component.exports